function initMarquee(section) {
  if (!section || section.dataset.marqueeInitialized) return;
  if (section.classList.contains('marquee--no-animation-desktop') && window.innerWidth > 900) {
    return;
  }

  const tracks = section.querySelectorAll('.marquee-track');
  if (section.classList.contains('custom-brands-logo')) {
    return;
  }
  section.dataset.marqueeInitialized = 'true';

  tracks.forEach((track) => {
    const originalContent = track.innerHTML;

    let appendCount = 1; // original content
    let safetyCounter = 0;

    while (
      track.scrollWidth < window.innerWidth * 2 &&
      safetyCounter < 20
    ) {
      track.insertAdjacentHTML('beforeend', originalContent);
      appendCount++;
      safetyCounter++;
    }

    const styles = getComputedStyle(section);
    const baseDuration = parseFloat(styles.getPropertyValue('--st-duration'));

    track.style.setProperty(
      '--st-duration',
      `${baseDuration * appendCount}s`
    );
  });
}

function initAllMarquees() {
  document
    .querySelectorAll('.marquee-container')
    .forEach(initMarquee);
}

document.addEventListener('DOMContentLoaded', initAllMarquees);

document.addEventListener('shopify:section:load', (event) => {
  const section =
    event.target.querySelector('.marquee-container') || event.target;

  initMarquee(section);
});

window.addEventListener('resize', () => {
  document.querySelectorAll('.marquee-container').forEach((section) => {
    if (
      section.classList.contains('marquee--no-animation-desktop') &&
      window.innerWidth <= 900 &&
      !section.dataset.marqueeInitialized
    ) {
      initMarquee(section);
    }
  });
});